
<ng-container *ngIf="isLoadingIndividualAcreages === false">

      <div class="contents">
        <div class="form_input">
          <h2 class="title">Acreage Description</h2>

          <form [formGroup]="individualAcreagesForm">
            <div class="input">
              <label for="">Terrain</label>
              <select formControlName="TerrainId" class="default_input reference-form">
                <option *ngFor="let terrain of terrains"
                [value]="terrain.id">{{ terrain.TerrainName }}</option>
              </select>
            </div>

            <div class="input">
              <label for="">Net Area</label>
              <input type="number"  formControlName="NetArea" class="default_input reference-form" />
            </div>
            <div class="input">
              <label for="">UOM</label>
              <select formControlName="MeasureId" class="default_input reference-form">
                <option  *ngFor="let measure of measures"
                [value]="measure.id">{{ measure.MeasureName }}</option>
              </select>
            </div>


            <div class="input">
              <label for="">Remarks</label>
              <input type="text" formControlName="Remarks" class="default_input reference-form" />
            </div>
          </form>
          <div class="btn_holder">
            <button class="default_primary-button" (click)="addNew(individualAcreagesForm.value)" type="submit">
              <ng-container *ngIf="selectedIndex === null">
                Add  &rarr;
              </ng-container>
              <ng-container *ngIf="selectedIndex !== null">
                Update  &rarr;
              </ng-container>
            </button>

            <div class="refresh">
              <button mat-button (click)="onReset()">
                 <i class="material-icons">
                  settings_backup_restore
                  </i>Reset</button>
              </div>
          </div>
        </div>




  <cradua-individual-acreages-table
  [individualAcreages]="individualAcreages"
  [selectedLessorInfo]="selectedLessorInfo"
  [selectedLandTitle]="selectedLandTitle"
  [terrains]="terrains"
  [measures]="measures"
  (emitEdit)="onEdit($event)"
  >
  </cradua-individual-acreages-table>
</div>

<div class="acquisition_submit">
  <button class="default_primary-button" (click)="onSubmit()" type="submit">
    Save
  </button>
  <button class="default_secondary-btn ml-2" (click)="onBack()" style="display:block;"> <i class="ti-arrow-left"></i> Back</button>
</div>

</ng-container>
<cradua-list-spinner
*ngIf="isLoadingIndividualAcreages === true"
>
</cradua-list-spinner>



